import React from 'react';

const CustomSelect = ({
    value,
    name,
    options = [],
    handleChange,
    label,
    labelClassName,
    className,
    error,
    holder,
    ...props
}) => {

    // Contenedor del select con tus variables de Tailwind
    const selectClasses = `
        w-full h-14 pl-4 pr-10 rounded-2xl border-2 transition-all appearance-none bg-no-repeat
        text-sm font-medium
        ${error
            ? 'border-cs-danger text-cs-danger bg-cs-danger/5'
            : 'border-cs-border text-cs-dark bg-cs-bg-alt focus:border-cs-primary focus:bg-white'
        } 
        ${className}
    `.trim();

    // Estilo para la flecha personalizada (SVG Base64 para no depender de archivos externos)
    const arrowStyle = {
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236B7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
        backgroundPosition: 'right 1rem center',
        backgroundSize: '1.2em',
    };

    return (
        <div className="flex flex-col w-full gap-1.5 group">
            {label && (
                <label className={`text-[11px] font-bold uppercase tracking-widest ml-1 transition-colors ${error ? 'text-cs-danger' : 'text-cs-muted group-focus-within:text-cs-primary'
                    } ${labelClassName}`}>
                    {label}
                </label>
            )}

            <div className="relative">
                <select
                    name={name}
                    value={value}
                    className={selectClasses}
                    style={arrowStyle}
                    onChange={handleChange}
                    {...props}
                >
                    <option value="" disabled>
                        {holder ?? 'Choose an option...'}
                    </option>
                    {options.map((item, index) => (
                        <option value={item.id} key={`${item.id}-${index}`}>
                            {item.name}
                        </option>
                    ))}
                </select>
            </div>

            {error && (
                <span className="text-[10px] font-bold text-cs-danger ml-2 animate-fadeIn">
                    {error}
                </span>
            )}
        </div>
    );
};

export default CustomSelect;